import './checkbox.scss';
import React, {useState} from 'react';
import {Icons} from '../../icons/icons';
import {SvgIcon} from '../../icons/svgIcon';
import classNames from 'clsx';
import {useTranslation} from 'react-i18next';

type FlexDirection = 'row' | 'row-reverse' | 'column' | 'column-reverse';
type CheckBoxJustifyContent = 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';

type InputProps = {
    value: boolean;
    onChange?: (value: boolean) => void;
    mayEdit: boolean;
    labelKey?: string;
    checkBoxFlexDirection?: FlexDirection;
    checkJustifyContent?: CheckBoxJustifyContent;
    className?: string
};

export const Checkbox = React.memo(({
                                        labelKey,
                                        mayEdit,
                                        onChange,
                                        value,
                                        checkBoxFlexDirection = 'row',
                                        checkJustifyContent = 'flex-start',
                                        className
                                    }: InputProps) => {
    const [localValue, setLocalValue] = useState<boolean>(value);
    const {t} = useTranslation();

    const onClick = () => {
        if (mayEdit) {
            onChange && onChange(!localValue);
            setLocalValue(!localValue);
        }
    };

    return (
        <div className={classNames('checkbox', className)} onClick={onClick} style={{
            '--flex-direction': checkBoxFlexDirection,
            '--justify-content': checkJustifyContent
        } as React.CSSProperties}>
            {mayEdit && <SvgIcon icon={localValue ? Icons.CHECKBOX_ON : Icons.CHECKBOX_OFF} className={classNames()}/>}
            {!mayEdit && localValue && <SvgIcon icon={Icons.CONFIRM} className={classNames()}/>}
            {!mayEdit && !localValue && <div>-</div>}
            {labelKey && <span>{t(labelKey)}</span>}
        </div>
    );
});
